import { useEffect } from 'react';
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-react';
import { getDefaultOTELInstrumentations, TracingInstrumentation } from '@grafana/faro-web-tracing';

import { useRumConfig } from './useRumConfig';

const COLLECT_URL = 'https://faro-collector-prod-eu-west-2.grafana.net/collect/e4347be34caaac03e16271ac74be0b43';

export function useInitialiseRUM() {
  const config = useRumConfig();

  useEffect(() => {
    if (config.data) {
      if (process.env.NODE_ENV === 'production') {
        const { apiKey } = config.data;

        initializeFaro({
          url: COLLECT_URL,
          apiKey,
          instrumentations: [
            ...getWebInstrumentations(),
            new TracingInstrumentation({
              instrumentations: getDefaultOTELInstrumentations({ ignoreUrls: [new RegExp(COLLECT_URL)] }),
            }),
          ],
          app: {
            name: __APP_NAME__,
            version: __APP_VERSION__,
          },
        });
      } else {
        // eslint-disable-next-line i18next/no-literal-string, no-console -- for development
        console.info('Mocking RUM...');
      }
    }
  }, [config.data]);
}
